module.exports = __webpack_public_path__ + "img/packageinfo.ece437e9.png";